<template>
  <div class="skeleton-box"></div>
</template>

<script>
export default {
  name: 'Skeleton'
}
</script>

<style scoped>
  /* Skeleton */
  .skeleton-box {
    display: inline-block;
    height: 200px;
    width: 100%;
    position: relative;
    overflow: hidden;
    background-color: #DDDBDD;
  }
  .skeleton-box:after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0));
    animation: shimmer 2s infinite;
    content: '';
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
</style>
